var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSchedule = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Create-Class-/-Schedule-/-default",
    transform: "translate(2.000000, 0.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9318182,1.97727273 L18.9318182,20.75 L-0.75,20.75 L-0.75,1.97727273 L18.9318182,1.97727273 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.33627273,
    y1: 4.33181818,
    x2: 3.33627273,
    y2: -2.64677169e-13,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.2183636,
    y1: 4.33181818,
    x2: 15.2183636,
    y2: -2.64677169e-13,
    id: "Stroke-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.4033219e-13,
    y1: 5.97072727,
    x2: 18.5554545,
    y2: 5.97072727,
    id: "Stroke-5"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSchedule, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/schedule.56ac2e43.svg";
export { ForwardRef as ReactComponent };